import { RtCommonApiRoutes } from 'RtExports/routes';
import {
	RateSheetGenerationCreateRequest,
	RateSheetGenerationProfileResponse,
	RateSheetGeneratorIndexResponse,
	RateSheetGeneratorProfileResponse
} from 'RtModels';
import { HttpResource } from 'RtUi/utils/http/resources/HttpResource';

export class RateSheetGeneratorResource extends HttpResource<
	RateSheetGeneratorIndexResponse,
	RateSheetGeneratorProfileResponse
> {
	constructor() {
		super(RtCommonApiRoutes.RateSheetGenerator);
	}
	public async create(params: any, misc: any) {
		return {} as RateSheetGeneratorProfileResponse;
	}

	public getProfile(
		rateSheetGeneratorId: number
	): Promise<RateSheetGeneratorProfileResponse> {
		return this.fetchWithRoute(RtCommonApiRoutes.RateSheetGenerator.Profile, {
			urlParams: {
				rateSheetGeneratorId
			}
		});
	}

	public createRateSheetGenerator(
		params: any
	): Promise<RateSheetGeneratorProfileResponse> {
		return this.fetchWithRoute(RtCommonApiRoutes.RateSheetGenerator.Create, {
			method: 'POST',
			body: params
		});
	}

	public async updateRateSheetGenerator(
		rateSheetGeneratorId: number,
		params: any
	): Promise<RateSheetGeneratorProfileResponse> {
		return this.fetchWithRoute(RtCommonApiRoutes.RateSheetGenerator.Update, {
			method: 'PUT',
			urlParams: {
				rateSheetGeneratorId
			},
			body: params
		});
	}

	public createRateSheetGeneration(
		rateSheetGeneratorId: number,
		notes: string
	): Promise<RateSheetGenerationProfileResponse> {
		return this.fetchWithRoute(RtCommonApiRoutes.RateSheetGeneration.Create, {
			method: 'POST',
			body: JSON.stringify({
				rateSheetGeneratorId,
				notes
			} as RateSheetGenerationCreateRequest)
		});
	}
}
